import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import imagesData from "../assets/images.json";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{
      position: "absolute",
      right: "20px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 20,
      background: "#00000070",
      color: "#fff",
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "24px"
    }}
  >
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    style={{
      position: "absolute",
      left: "20px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 20,
      background: "#00000070",
      color: "#fff",
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "24px"
    }}
  >
    ❮
  </div>
);

function RandomCarousel() {
  const [shuffledImages, setShuffledImages] = useState([]);

  const shuffleArray = (arr) => arr.sort(() => Math.random() - 0.5);

  useEffect(() => {
    setShuffledImages(shuffleArray([...imagesData]));
  }, []);

  const settings = {
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,       // SHOW ONE IMAGE
    slidesToScroll: 1,
    pauseOnHover: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div style={{ width: "", margin: 0, position: "relative" }}>
      <Slider {...settings}>
        {shuffledImages.map((img, index) => (
          <div key={index} style={{ width: "100vw" }}>
            <img
              src={img.url}
              alt="carousel"
              style={{
                width: "70vw",         // full browser width
                height: "auto", 
                margin: "0 auto",        // auto height
                objectFit: "cover",
                display: "block"
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default RandomCarousel;
